module.exports = __webpack_public_path__ + "static/img/partner-img.2296680.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/partner-img.png
// module id = +cdy
// module chunks = 2